import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";
import React from "react";
import qs from 'query-string';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Onlineshow } from '@dmi-mch/services';
import { Button } from '@mch-group/uikit-components';
import Tip from './Tip';

var ArtworkQRCodeDownloadButton = function ArtworkQRCodeDownloadButton(_ref) {
  var context = _ref.context,
      artworkId = _ref.artworkId,
      eventId = _ref.eventId,
      downloadQRCodeLabel = _ref.downloadQRCodeLabel,
      qrCodeInfoLabel = _ref.qrCodeInfoLabel,
      isDownloadAllArtwork = _ref.isDownloadAllArtwork,
      isAlignItemToCenter = _ref.isAlignItemToCenter;
  var onlineShowService = new Onlineshow(context);

  var toDataURL = function toDataURL(params) {
    var hostName = window.location.origin;
    var url = "".concat(hostName, "/msvc/v1/qrcode/artworks?").concat(qs.stringify(params));
    return fetch(url).then(function (response) {
      return response.blob();
    }).then(function (blob) {
      return URL.createObjectURL(blob);
    });
  };

  var downloadQRCode = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(name, type) {
      var response, token, requestParams, a;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return onlineShowService.getTemporaryToken();

            case 2:
              response = _context.sent;
              token = response.data.token;
              requestParams = {
                token: token,
                eventIds: eventId
              };

              if (!isDownloadAllArtwork) {
                requestParams.artworkIds = artworkId;
              }

              a = document.createElement('a');
              a.style.display = 'none';
              _context.next = 10;
              return toDataURL(requestParams);

            case 10:
              a.href = _context.sent;
              a.download = "".concat(name, ".").concat(type);
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function downloadQRCode(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement(StyledContainer, {
    isAlignItemToCenter: isAlignItemToCenter
  }, /*#__PURE__*/React.createElement(Button, {
    iconAlign: "left",
    onClick: function onClick() {
      return downloadQRCode('Gallery_artist_artwork', 'zip');
    },
    variant: "secondary",
    icon: "download"
  }, downloadQRCodeLabel), isDownloadAllArtwork && /*#__PURE__*/React.createElement("span", {
    className: "info"
  }, /*#__PURE__*/React.createElement(Tip, {
    align: "right",
    content: qrCodeInfoLabel
  })));
};

var StyledContainer = styled.div.withConfig({
  displayName: "ArtworkQRCodeDownloadButton__StyledContainer",
  componentId: "sc-dqcu6y-0"
})(["display:flex;align-items:center;grid-gap:10px;", " .info{svg{width:34px;height:34px;}}"], function (props) {
  return props.isAlignItemToCenter ? 'justify-content: center;' : '';
});
ArtworkQRCodeDownloadButton.propTypes = {
  context: PropTypes.object,
  artworkId: PropTypes.number,
  eventId: PropTypes.number,
  downloadQRCodeLabel: PropTypes.string,
  qrCodeInfoLabel: PropTypes.string,
  isDownloadAllArtwork: PropTypes.bool,
  isAlignItemToCenter: PropTypes.bool
};
export default ArtworkQRCodeDownloadButton;